import { render, staticRenderFns } from "./FlowBox.vue?vue&type=template&id=4004d722&scoped=true"
import script from "./FlowBox.vue?vue&type=script&lang=js"
export * from "./FlowBox.vue?vue&type=script&lang=js"
import style0 from "./FlowBox.vue?vue&type=style&index=0&id=4004d722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4004d722",
  null
  
)

export default component.exports